import React from 'react'
import { SkillsContainer, SkillsWrapper, SkillsWrap, SkillsH1, SkillsUl, SkillsLi, SkillsImg } from './SkillsElements'

const Skills = () => {
    return (
        <SkillsContainer id="skills" className="darkBackground lightColor">
            <SkillsH1>Mes principales compétences</SkillsH1>
            <SkillsWrapper>
                <SkillsWrap>
                    <SkillsUl data-delay="10" >
                        {
                            skillsElements.map(element => {
                                return (
                                    <SkillsLi className="lightBackground"><SkillsImg src={element.img} /></SkillsLi>
                                )
                            })
                        }
                    </SkillsUl>
                </SkillsWrap>
            </SkillsWrapper>
        </SkillsContainer>
    )
}

export default Skills

let skillsElements = [
    {
        id: 1,
        img: '/images/htmlLogo.png',
    },
    {
        id: 2,
        img: '/images/cssLogo.png',
    },
    {
        id: 3,
        img: '/images/javascriptLogo.png',
    },

    {
        id: 4,
        img: '/images/phpLogo.png',
    },
    {
        id: 5,
        img: '/images/javaLogo.png',
    },
    {
        id: 6,
        img: '/images/cSharpLogo.png',
    },
    {
        id: 7,
        img: '/images/sqlLogo.png',
    },
    {
        id: 8,
        img: '/images/gitlabLogo.png',
    },
]
